import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import EnquiryService from 'client/services/Enquiry/Enquiry.service';

const initialState = {
    draftEnquiry: null,
    createdEnquiry: null,
    loading: false,
    error: false,
    errorCode: 0,
    errorMessage: null
};

export const createEnquiry = createAsyncThunk('enquiry/createEnquiry', async (payload, { rejectWithValue }) => {
    try {
        const response = await EnquiryService.postEnquiry(payload);
        return response;
    } catch (err) {
        return rejectWithValue({ errorCode: err.errorCode ?? err.statusCode ?? 500, errorMessage: err.errorMessage ?? err.message ?? 'unknown' });
    }
});

export const enquirySlice = createSlice({
    name: 'enquiry',
    initialState: { ...initialState },
    reducers: {
        clearDraftEnquiry: state => {
            return {
                ...state,
                draftEnquiry: null
            };
        },
        setDraftEnquiry: (state, action) => {
            const enquiry = action?.payload;
            if (!enquiry) {
                return;
            }
            return { ...state, draftEnquiry: action };
        },
        clearCreatedEnquiry: state => {
            return {
                ...state,
                createdEnquiry: null,
                loading: false,
                error: false,
                errorCode: 0,
                errorMessage: null
            };
        }
    },
    extraReducers: {
        [createEnquiry.pending]: state => {
            return {
                ...state,
                loading: true,
                error: false,
                createdEnquiry: null
            };
        },
        [createEnquiry.fulfilled]: (state, action) => {
            const enquiry = action.payload;
            if (enquiry?.enquiryId) {
                return {
                    ...state,
                    loading: false,
                    error: false,
                    createdEnquiry: enquiry
                };
            } else {
                return {
                    ...state,
                    loading: false,
                    error: true,
                    createdEnquiry: null
                };
            }
        },
        [createEnquiry.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                error: true,
                errorMessage: action.payload.errorMessage,
                errorCode: action.payload.errorCode,
                createdEnquiry: null
            };
        }
    }
});

export const {
    clearDraftEnquiry,
    setDraftEnquiry,
    clearCreatedEnquiry
} = enquirySlice.actions;

export default enquirySlice.reducer;
